<template>
  <div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.Introduction')}}</h4>
      <p>{{$t('helpCenter.Introduction_1')}}</p>
      <p>{{$t('helpCenter.Introduction_2')}}</p>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_two')}}</h4>
      <table cellspacing="0" cellpadding="0" border="0" class="content-table">
        <tr>
          <th>
            <div class="cell">{{$t('helpCenter.date')}}</div>
          </th>
          <th>
            <div class="cell">{{$t('helpCenter.sdkVersion')}}</div>
          </th>
          <th style="width:70%">
            <div class="cell">{{$t('helpCenter.updata')}}</div>
          </th>
        </tr>
        <tr>
          <td>
            <div class="cell">2021.01.01</div>
          </td>
          <td>
            <div class="cell">1.0.0</div>
          </td>
          <td>
            <div class="cell">{{$t('helpCenter.updataInfo')}}</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_3_title')}}</h4>
      <table cellspacing="0" cellpadding="0" border="0" class="content-table">
        <tr>
          <th>
            <div class="cell">{{$t('helpCenter.语言')}}</div>
          </th>
          <th>
            <div class="cell">{{$t('helpCenter.最新版本')}}</div>
          </th>
          <th>
            <div class="cell">{{$t('helpCenter.项目示例')}}</div>
          </th>
          <th>
            <div class="cell">{{$t('helpCenter.开发环境')}}</div>
          </th>
        </tr>
        <tr>
          <td>
            <div class="cell">JAVA</div>
          </td>
          <td>
            <div class="cell"><a href="https://download.jtjms-sa.com/open/jt-openapi-sdk.zip" download="">jt-openapi-sdk.zip</a></div>
          </td>
          <td>
            <div class="cell"><a href="https://download.jtjms-sa.com/open/Project%20example.zip" download="">Project example.zip</a></div>
          </td>
          <td>
            <div class="cell">{{$t('helpCenter.支持JAVA版本')}}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="cell">PHP</div>
          </td>
          <td>
            <div class="cell"></div>
          </td>
          <td>
            <div class="cell"><a href="https://download.jtjms-sa.com/open/PHP%20signature%20example.zip" download="">PHP signature example.zip</a></div>
          </td>
          <td>
            <div class="cell">{{$t('helpCenter.支持PHP')}}</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_4_title')}}</h4>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>com.yl.jms.sdk
├── auth // {{$t('helpCenter.签名相关类')}}
├──client // {{$t('helpCenter.公用类')}}
├──exception // {{$t('helpCenter.异常相关类')}}
├──http // {{$t('helpCenter.Http通信相关类')}}
└──JtExpressApi // {{$t('helpCenter.开放平台api通用接口')}}
└──JtExpressExecutor // {{$t('helpCenter.执行器接口')}}</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_5_title')}}</h4>
      <div v-html="$t('helpCenter.sdk_5_txt')">
        <!-- <p>1.SDK压缩工具包由开放平台提供。</p>
        <p>2.将开放平台提供的`jt-openapi-sdk.zip`解压后，复制到工程文件夹中。</p>
        <p>3.点击 File -> Project Structure（快捷键 Ctrl + Alt + Shift + s），点击Project Structure界面左侧的“Modules。</p>
        <p>4.在 “Dependencies” 标签界面下，点击右边的 “+”号，选择第一个选项“JARs or directories...”，选择相应的jar包，点“OK”，jar包添加成功。</p>
        <p>5.具体接口的SDK调用方法可以下载‘示例实用项目.zip’进行参考。</p> -->
      </div>

    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_6_title')}}</h4>
      <p>{{$t('helpCenter.sdk_6_txt')}}</p>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>&lt;dependencies&gt;
    &lt;!-- https://mvnrepository.com/artifact/org.apache.commons/commons-lang3 --&gt;
    <!-- &lt;!--commons-lang3依赖版本不能低于3.9--&gt; -->&lt;!--commons-lang3 dependent release of not less than 3.9--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.apache.commons&lt;/groupId&gt;
        &lt;artifactId&gt;commons-lang3&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
    &lt;!-- https://mvnrepository.com/artifact/org.slf4j/slf4j-api --&gt;
     <!-- &lt;!--slf4j-api依赖版本不能低于1.7.30--&gt; -->&lt;!--slf4j-api-dependent release of not less than 1.7.30--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.slf4j&lt;/groupId&gt;
        &lt;artifactId&gt;slf4j-api&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
     <!-- &lt;!--fastjson依赖版本不能低于1.2.70--&gt; -->&lt;!--fastjson dependent version can not be lower than 1.2.70--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;com.alibaba&lt;/groupId&gt;
        &lt;artifactId&gt;fastjson&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
        &lt;scope&gt;compile&lt;/scope&gt;
    &lt;/dependency&gt;
     <!-- &lt;!--httpclient依赖版本不能低于4.4.1--&gt; -->&lt;!--Version 4.4.1 can not be lower than rely httpclient--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.apache.httpcomponents&lt;/groupId&gt;
        &lt;artifactId&gt;httpclient&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
&lt;/dependencies&gt;</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_7_title')}}</h4>
      <div v-html="$t('helpCenter.sdk_7_txt')">
        <p>JtExpressApi是极兔开放平台api通用执行器,为使用极兔开放平台的开发人员提供了一系列的交互方法。</p>
        <p>用户可以参考如下代码新建一个JtExpressApi,初始化完成后建议单例使用,避免重复创建:</p>
      </div>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>public class SdkTestDemo{
    <!-- public static final String apiAccount="api账号";
    public static final String privateKey="平台密钥";
    public static final String customerCode="协议客户账号";
    public static final String orderPassword="协议客户密码"; -->public static final String apiAccount="api account";
    public static final String privateKey="Platform key";
    public static final String customerCode="Agreement customer account";
    public static final String orderPassword="Agreement customer password";
    <!-- //用户要调用的接口地址 -->//User interface address to call
    public static final String url = "https://demoopenapi.jtjms-sa.com/webopenplatformapi/api/location/getLocation";
    public static void main(String[] args) throws IOException {
        <!-- //创建授权用户实体 -->//Creating entity authorized users
        ClientConfiguration clientConfiguration = new ClientConfiguration(apiAccount,privateKey);
        <!-- //当调用postByCustom方法时需要customerCode和orderPassword --> //CustomerCode and orderPassword are required when calling the postByCustom method
        clientConfiguration.setCustomerCode(customerCode);
        clientConfiguration.setCustomerPwd(orderPassword);
        JtExpressApi jtExpressApi = new JtExpressApiOperator(clientConfiguration);
        <!-- //把接口需要的参数封装到map -->//Encapsulate the parameters required by the interface into map
        Map&lt;String, Object&gt; map = new HashMap&lt;&gt;();
        map.put("countryCode","CHN");
        <!-- //调用执行器,调用接口方法 -->//Call the executor, call the interface method
        JSONObject location = jtExpressApi.post(map,url);
        System.out.println(location);
    }
}</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">{{$t('helpCenter.sdk_8_title')}}</h4>
      <div v-html="$t('helpCenter.sdk_8_txt')">
        <p>如果你是用springboot框架来调用API开放平台-SDK相关接口,建议把JtExpressApi放到spring容器中进行管理,</p>
        <p>用户可以参考如下代码新建一个配置类:</p>
      </div>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>@Configuration
public class SdkDemoConfig {
    <!-- //api账号 -->//api account
    @Value("${apiAccount}")
    public String apiAccount;
    
    <!-- //平台密钥 -->//Platform key
    @Value("${privateKey}")
    public String privateKey;
    
    <!-- //协议客户账号 -->//Agreement customer account
    @Value("${customerCode}")
    public String customerCode;
    
    <!-- //协议客户密码 -->//Agreement customer password
    @Value("${orderPassword}")
    public String orderPassword;

    @Bean
    public JtExpressApi jtExpressApi(){
     <!-- //创建授权用户实体 -->//Creating entity authorized users
        ClientConfiguration clientConfiguration = new ClientConfiguration(apiAccount,privateKey);
        <!-- //当调用postByCustom方法时需要customerCode和orderPassword -->//CustomerCode and orderPassword are required when calling the postByCustom method
        clientConfiguration.setCustomerCode(customerCode);
        clientConfiguration.setCustomerPwd(orderPassword);
        JtExpressApi jtExpressApi = new JtExpressApiOperator(clientConfiguration);
        return jtExpressApi;
    }
}</code></pre>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 30px;
  font-size: 14px;
  font-weight: 400;
  color: #61666d;
  line-height: 22px;
  .content-subTitle {
    height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: #2b2d42;
    line-height: 22px;
    margin-bottom: 10px;
    &.bodySign {
      margin: 50px 0 10px;
    }
  }
  ::v-deep p {
    margin-top: 15px;
    word-break: break-all;
  }
}
.content-table {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  font-size: 14px;
  color: #606266;
  border-radius: 4px;
  th,
  td {
    padding: 12px 0;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    &:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    .cell {
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  th {
    background-color: #f9fafc !important;
    border-top: 1px solid #ebeef5;
    font-weight: 400;
    color: #4c4d57;
  }
}
.pre_api {
  background: #f9fafc;
  border: 1px solid #dcdee1;
  border-radius: 4px;
  box-sizing: border-box;
  max-height: 400px;
  overflow: auto;
  margin-top: 15px;
  .jv-code {
    padding: 20px;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
    white-space: pre-wrap;
    color: #525252;
    font-size: 14px;
    font-family: Consolas, Menlo, Courier, monospace;
  }
}
</style>
